import React from 'react';
import styles from './sidebar-header.styl';

const SidebarHeader = ({title}: {title: string}): JSX.Element => {
  return (
    <header className={styles.container}>
      <h2>{title}</h2>
    </header>
  );
};

export default SidebarHeader;
